import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdsService } from '../admin/services/ads.service';
import { BookmarkService } from '../services/bookmark.service';

@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss']
})
export class FavoritesComponent implements OnInit {
  adsListUser:[] = []
  adsListAdmin: any = []

  shuffledAdmin: any = []
  shuffledUser: any = []

  userAd
  adminAd
  emptyUser: boolean = false
  emptyAdmin: boolean = false

  emptyAds: boolean = false

  counter: number = 0

  // isCollapsed = true;

  maxLength = 250
  constructor(private router: Router,private bookmarkService: BookmarkService, private adsService: AdsService) { }

  events:any = [];
  show = false;
  ngOnInit(): void {
    this.bookmarkService.getMyBookmarkEvents()
      .then((res:any) => {
        this.events=res.events.data;
        console.log(this.events)
        for(let i =0;i<this.events.length; i++){
        if(this.events[i].description.length>this.maxLength){
          this.checkDataLength(this.events[i]);
          this.events = this.events.map(item => ({
            ...item,
            isCollapsed:true,
          }));
        }
        if(this.events[i].website == "" || this.events[i].website == null){
          this.events[i].noWebsite = false
        }
        else {
          this.events[i].noWebsite = true
        }
        }



        this.events = this.events.map(item => ({
          ...item,
          passedEvent:true,
          firstDate: '',
          lastDate: ''
        }));
        for (let k=0;k<this.events.length; k++){
          let dates: any[] = this.events[k].event_dates;
          let validDates: any[] = [];
          dates.forEach((date) => {
            if (new Date(date.date) > new Date() || new Date(date.date).toDateString() === new Date().toDateString()) {
              validDates.push(date)
            }
          });
          this.events[k].event_dates = validDates;

          if (validDates.length < 1 || validDates == undefined){this.events[k].passedEvent = true}
          else if(validDates.length == 1){
            this.events[k].firstDate= validDates[0].date
            this.events[k].passedEvent = false
          }
          else {
            this.events[k].passedEvent = false
          this.events[k].firstDate = validDates[0].date
          let indexOfArray = validDates.length -1
          this.events[k].lastDate = validDates[indexOfArray].date
          }
        }
        
        
      })
      .catch((error) => {
        console.log(error)
      })
     this.adsService.getAllAdsUser().then((res:any) => {
        console.log("ADS USER",res.ads.data)
        this.adsListUser=res.ads.data
        if(res.ads.data.length != 0){
          // console.log("USER ADS",this.adsListUser)
        this.shuffledUser= this.shuffle(this.adsListUser)
        // console.log("SHUFFLED USERS",this.shuffledUser)
        this.userAd = this.shuffledUser[0]
        // console.log(this.userAd)
        }
        else {this.emptyUser = true}
        console.log(this.emptyUser)
        
      })
      this.adsService.getAllAds("123").then((res:any) => {
        console.log("ADS ADMIN",res.ads.data)
        if(res.ads.data.length != 0 ){
        for(let i=0;i<res.ads.data.length; i++){
          if(res.ads.data[i].status == 1 ){
            this.adsListAdmin.push(res.ads.data[i])
            this.counter = 1
          }
          else {
            if (this.counter == 0){this.emptyAdmin = true}
            }
        }
      } else {
        if (this.counter == 0){this.emptyAdmin = true}
        }
        // this.adsListAdmin=res.ads.data
        // console.log("ADMIN ADS",this.adsListAdmin)
        this.shuffledAdmin= this.shuffle(this.adsListAdmin)
        // console.log("SHUFFLED ADMIN",this.shuffledAdmin)
        this.adminAd = this.shuffledAdmin[0]
        // console.log(this.adminAd)
        // if(this.emptyUser == false && this.emptyAdmin == false){
        //   this.emptyAds = false
        // }
      })
      
      
  }
  unfavorite(id) {
    let data =
    {
      'event_id': id
    }
    this.bookmarkService.bookmarkEvent(data)
      .then((res) => {
        let filteredArray = this.events.filter(o =>o.id !== id)
        this.events = filteredArray
        console.log(this.events)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  checkDataLength(data) {
    for(let i =0;i<this.events.length; i++){
      if(this.events[i].id == data.id){
        if(data.description.length >= 250){
    this.events[i].isReadMore = true
  }
      }
    }
  }

  shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  navigate(url){
    window.open("https://"+url, "_blank")
  }

  goToEventPage(item) {
    this.router.navigate(['event', item.link]);
  }

}
